<section class="nearby-section" #nearbySection>
  <div class="container">
    <div class="section-header">
      <h2 class="section-title">Classes Near You</h2>
      <p class="section-subtitle">Recurring dance classes at studios in your area</p>
    </div>

    @if (loading) {
      <div class="loading-state">
        <div class="loading-spinner"></div>
        <p>Loading nearby classes...</p>
      </div>
    }

    @if (error) {
      <div class="error-state">
        <p>{{ error }}</p>
        <button type="button" (click)="loadClasses(location)" class="retry-btn">Try Again</button>
      </div>
    }

    @if (!loading && !error) {
      @if (classes.length === 0) {
        <div class="empty-state">
          <p>No classes found near your location. Try increasing your search radius.</p>
        </div>
      } @else {
        <div class="events-grid">
          @for (cls of classes; track cls.id) {
            <a [routerLink]="['/classes', cls.id]" class="event-card">
              <div class="event-image">
                <img [src]="cls.imageUrl || placeholderImage" [alt]="cls.name" [title]="cls.name">
                @if (cls.danceGenre) {
                  <div class="event-type">{{ cls.danceGenre }}</div>
                }
              </div>
              <div class="event-content">
                <h3 class="event-title">{{ cls.name }}</h3>
                <div class="class-meta">
                  @if (cls.level) {
                    <span class="level-badge">{{ cls.level }}</span>
                  }
                </div>
                <div class="event-details">
                  <div class="event-location">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>{{ cls.studio.name }}, {{ cls.studio.city }}</span>
                  </div>
                  <div class="event-date">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <span>{{ cls.dayOfWeek }} · {{ formatTime(cls.startTime) }}</span>
                  </div>
                </div>
                <div class="event-footer">
                  <span class="event-price">${{ cls.cost.toFixed(2) }}</span>
                  <span class="view-btn">View Class</span>
                </div>
              </div>
            </a>
          }
        </div>

        <div class="view-more-wrap">
          <a
            routerLink="/classes"
            [queryParams]="viewMoreParams"
            class="view-more-btn"
          >View More Classes</a>
        </div>
      }
    }
  </div>
</section>
